// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8e-0";
export var optionCard = "_8e-1";